module.exports = __webpack_public_path__ + "spotify_logo.ed2963bc5996c25fe785c7e0c6e5a065.png";